import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';

import { Visibility, Edit } from '@material-ui/icons';
import { Checkbox, Grid, IconButton,  } from '@material-ui/core';
import { Note } from '@material-ui/icons';
import { Form, Select as SelectAntd, Input } from 'antd';
import InvisibleContent from '@components/Shared/InvisibleContent';

import ButtonWithIcon from '@components/Shared/Buttons/ButtonWithIcon';
import Button from '@components/Shared/Buttons/Button';
import TableCustomKeysNoPagination from '@components/Shared/Tables/TableCustomKeysNoPagination';

import { TitlePage } from '@src/@styles/styles.global';
import { useAuth } from '@hooks/AuthenticateContext';
import { FormatDate } from '@utils/formats';
import Modal from '@src/components/Shared/Modal/ModalPure';
import RecusarLote from '@src/Pages/Private/Cliente/Admin/InsercaoDoacoes/Modais/RecusarLote';
import RecusarDoacao from '@src/Pages/Private/Cliente/Admin/InsercaoDoacoes/Modais/RecusarDoacao';


import Services, {
  IDoacoes,
  IDoacoesResultTable,
} from './services';


const columnsLabel = {
  dataCadastro: 'Data cadastro',
  idDoacao: 'Id doação',
  IDCadastro: 'ID cadastro',
  NomeCadastro: 'Nome',
  SolicitadoPor: 'Usuário responsável',
  Valor: 'Valor',
  origemDoacaoDescricao: 'Origem doação',
};



interface IProps {
  idPerfil: number;
  functionReload?: Function;
  idSolicitacao: number;
}

const ListLotesPendentes: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [formRef] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<IDoacoes[]>([]);

  const { user, signOut } = useAuth();

  const [dadosSelecionadas, setDadosSelecionadas] = useState<string[]>([]);
  const [lotes, setLotes] = useState<any[]>([]);
  const [loteSelecionado, setLoteSelecionado] = useState<string | null>(null);
  const [reabrir, setReabrir] = useState(false);
  const [openModalRecuseLote, setOpenModalRecuseLote] = useState(false);
  const [openModalRecuseDoacao, setOpenModalRecuseDoacao] = useState(false);


  const carregarLotes = async () => {
    setLoading(true);
    let status = 2;
    const response = await Services.GetLotesFechados(status);
    if (!response.error) {
      setLotes(response.data);
    } else {
     // enqueueSnackbar('Erro ao carregar lotes', { variant: 'error' });
    }
    setLoading(false);
    //setReabrir(false);
  };

  const handleApproveDoacoes = async () => {
    if (dadosSelecionadas.length === 0) {
      enqueueSnackbar('Nenhuma doação selecionada', { variant: 'warning' });
      return;
    }
    setLoading(true);
    const response = await Services.AprovarDoacoes(
      dadosSelecionadas.map(Number),
      'Aprovado pelo gestor'
    );
    if (!response.error) {
      enqueueSnackbar('Doações aprovadas com sucesso!', { variant: 'success' });
      setDadosSelecionadas([]);

    } else {
      enqueueSnackbar('Erro ao aprovar doações', { variant: 'error' });
    }
    setLoading(false);
  };


  const handleApproveLote = async () => {
    setLoading(true);
    const response = await Services.AprovarLote(
      Number(loteSelecionado)
    );
    if (!response.error) {
      enqueueSnackbar('Lote aprovada com sucesso!', { variant: 'success' });
      formRef.resetFields();
      await setData([]);
      await carregarLotes();
      await setLoteSelecionado(null);

      //window.location.reload();
    } else {
      enqueueSnackbar('Erro ao aprovar doações', { variant: 'error' });
    }
    setLoading(false);
  };



  const handleReabrirLote = async () => {
    setLoading(true);
    const response = await Services.ReabrirLote(
      Number(loteSelecionado), user.id
    );
    if (!response.error) {
      enqueueSnackbar('Lote reaberto com sucesso!', { variant: 'success' });
      formRef.resetFields();
      await setData([]);
      await setLoteSelecionado(null);
      await carregarLotes();
      //window.location.reload();
    } else {
      enqueueSnackbar('Erro ao reabrir o lote', { variant: 'error' });
    }
    setLoading(false);
  };


  const selectedDatas = (value: IDoacoesResultTable) => {
    if (dadosSelecionadas.filter(x => x === value.idDoacao).length <= 0) {
      setDadosSelecionadas([...dadosSelecionadas, value.idDoacao]);
    } else {
      const newArray = dadosSelecionadas.filter(function (item) {
        return item !== value.idDoacao;
      });
      setDadosSelecionadas(newArray);
    }
  };

  useEffect(() => {

    carregarLotes();
  }, [enqueueSnackbar]);

  useEffect(() => {
    const carregarDoacoesPorLote = async () => {
      if (!loteSelecionado) {
        setData([]);
        return;
      }
      setLoading(true);
      const response = await Services.GetDoacoesPorLote(Number(loteSelecionado));
      if (!response.error && response.data) {
        setData(response.data);
      } else {
        setData([]);
        enqueueSnackbar('Erro ao carregar doações do lote', { variant: 'error' });
      }
      setLoading(false);
      setReabrir(false);
    };
    carregarDoacoesPorLote();
  }, [loteSelecionado, enqueueSnackbar]);


  const quantidadeItens = ( data.length - dadosSelecionadas.length )

  const finishRecuseSolicitacao = async () => {
    formRef.resetFields();
      await setData([]);
      await carregarLotes();
      await setLoteSelecionado(null);
    setOpenModalRecuseLote(false);
  };


  useEffect(() => {
    window.document.title = 'CRM - Listagem lotes';
  }, []);


   {/*/Bloqueio inspecionar
   useEffect(() => {
  if (user.role !== 'ADM SOCIALLIS') {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'F12') {
        event.preventDefault();
        alert('F12 está desativado.');
      }
      if (event.ctrlKey && event.shiftKey && event.key === 'I') {
        event.preventDefault();
        alert('Ctrl+Shift+I está desativado.');
      }
      if (event.ctrlKey && event.shiftKey && event.key === 'J') {
        event.preventDefault();
        alert('Ctrl+Shift+J está desativado.');
      }
      if (event.ctrlKey && event.key === 'U') {
        event.preventDefault();
        alert('Ctrl+U está desativado.');
      }
    };

    const detectDevTools = () => {
      const threshold = 160;
      const widthThreshold = window.outerWidth - window.innerWidth > threshold;
      const heightThreshold = window.outerHeight - window.innerHeight > threshold;

      if (widthThreshold || heightThreshold) {
        alert('Ferramentas de desenvolvedor detectadas.');
        window.location.href = '/';
      }
    };

    const interval = setInterval(detectDevTools, 1000);

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      clearInterval(interval);
    };
  }
}, [user.role]);*/}


  return (
    <Grid container>
      <Grid item md={12} xs={12}>
        <TitlePage style={{ margin: 5 }}>Lotes pendentes</TitlePage>
      </Grid>

      <Modal
          title="Recusar lote"
          size="medio"
          openModal={openModalRecuseLote}
          controlModal={(value: boolean) =>
            setOpenModalRecuseLote(value)
          }
        >
          <RecusarLote
            id_lote={Number(loteSelecionado)}
            finish={finishRecuseSolicitacao}

          />
        </Modal>

        <Modal
          title="Recusar doação"
          size="medio"
          openModal={openModalRecuseDoacao}
          controlModal={(value: boolean) =>
            setOpenModalRecuseDoacao(value)
          }
        >
          <RecusarDoacao
            id_lote={dadosSelecionadas}
            finish={finishRecuseSolicitacao}
          />
        </Modal>

      <Grid
        container
        alignItems="center"
        item
        md={12}
        xs={12}
        style={{ margin: 5 }}
      >
        <Grid item md={3} xs={4} style={{ margin: 5 }} >
          <Form.Item>
            <SelectAntd
              style={{ width: '80%' }}
              placeholder="Selecione um lote"
              loading={loading}
              value={loteSelecionado ?? undefined}
              onChange={value => setLoteSelecionado(value)}
            >
              {lotes.map((lote: any) => (
                <SelectAntd.Option key={lote.id} value={lote.id}>
                  {lote.id + " - " + lote.nomeUsuario}
                </SelectAntd.Option>
              ))}
            </SelectAntd>
          </Form.Item>
        </Grid>

       <InvisibleContent visible={reabrir === false && dadosSelecionadas.length <= 0 || quantidadeItens === 0}>
          <Grid item md={2} xs={4} style={{ margin: 5 }}>
            <Button
              color="secondary"
              fullWidth
              style={{ height: 37, width: 150 }}
              onClick={handleApproveLote}
            >
              <Note style={{ marginRight: 10 }} /> Aprovar lote
            </Button>
          </Grid>

          <Grid item md={2} xs={4} style={{ margin: 5 }}>
            <Button
              color="tertiary"
              fullWidth
              style={{ height: 37, width: 150 }}
              onClick={() => setOpenModalRecuseLote(true)}
            >
              <Note style={{ marginRight: 10 }} /> Recusar lote
            </Button>
          </Grid>

          <Grid item md={2} xs={4} style={{ margin: 5 }}>
            <Button
              color="quartenary"
              fullWidth
              style={{ height: 37, width: 150 }}
              onClick={handleReabrirLote}
            >
              <Note style={{ marginRight: 10 }} /> Reabrir lote
            </Button>
          </Grid>
        </InvisibleContent>

        <InvisibleContent visible={dadosSelecionadas.length > 0 && reabrir === false && quantidadeItens !== 0}>
        < Grid item md={2} xs={4} style={{ margin: 5 }}>
            <ButtonWithIcon
              color="secondary"
              fullWidth
              onClick={handleApproveDoacoes}
              titleButton="Aprovar doações"
            />
          </Grid>

          <Grid item md={2} xs={4} style={{ margin: 5 }}>
            <ButtonWithIcon
              color="tertiary"
              fullWidth
              onClick={() => setOpenModalRecuseDoacao(true)}
              titleButton="Recusar doações"
            />
          </Grid>

        </InvisibleContent>
      </Grid>

     <Grid item lg={12} xs={12}>
        <TableCustomKeysNoPagination
          Selected={(e: IDoacoesResultTable) => (
            <Grid container justifyContent="center">
              <Checkbox
                onChange={() => selectedDatas(e)}
                checked={dadosSelecionadas.filter(x => x === e.idDoacao).length > 0}
              />
            </Grid>
          )}
          loading={loading}
          columns={[columnsLabel]}
          FieldsBold={['NomeCadastro', 'SolicitadoPor']}
          data={data?.map((d: any) => ({
            dataCadastro: FormatDate(d.dataCadastro),
            IDCadastro: d.doadorId,
            NomeCadastro: d.doadorNome,
            SolicitadoPor: d.usuarioCadastroNome,
            Valor: d.valorDoacao.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
            origemDoacaoDescricao: d.origemDoacaoDescricao,
            idDoacao: d.idDoacao,
          })) ?? []}
          keys={[
            'dataCadastro',
            'IDCadastro',
            'NomeCadastro',
            'SolicitadoPor',
            'Valor',
            'origemDoacaoDescricao',
          ]}
          Actions={[
            {
              Button: (row: IDoacoesResultTable) => {
                return (
                  <IconButton
                    onClick={() => window.open(`/cadastro/${row.IDCadastro}/`)}
                  >
                    <Visibility />
                  </IconButton>
                );
              },
            },
          ]}
        />
      </Grid>




    </Grid>
  );
};

export default ListLotesPendentes;
